import { Priority } from "react-native-fast-image";

export const priority = {
  low: "low" as Priority,
  normal: "normal" as Priority,
  high: "high" as Priority,
};
